import router from './router'
import { useUserStore } from '@/store/user'
import { getCookies } from '@/utils/auth'

// 白名单：无需登录即可访问的页面
const whiteList = ['/weLogin']

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || '预约' // 使用路由的meta.title或者一个默认标题

  const userStore = useUserStore()

  // 登录页直接放行
  if (whiteList.includes(to.path)) {
    next()
    return
  }

  // 已登录（存在 weToken）且刷新后 store 中用户信息丢失，重新请求 getInfo 接口
  if (getCookies('weToken') && !userStore.userName) {
    try {
      await userStore.getInfo()
    } catch (error) {
      console.error('获取用户信息失败：', error)
    }
  }

  next()
})